import dayjs from 'dayjs';

/**
 * Returns a `getDayProps` callback for Mantine DatePickerInput that highlights
 * today's date with a subtle gray outline so users can orient themselves in the
 * calendar.
 */
export const getTodayDayProps = (date: Date) => {
  if (dayjs(date).isSame(dayjs(), 'day')) {
    return {
      style: {
        border: '2px solid var(--mantine-color-gray-4)',
        borderRadius: 'var(--mantine-radius-sm)',
      },
    };
  }
  return {};
};

